export default __webpack_public_path__ + "static/media/close-icon-grey.f3a2dbf0.svg";